export const ASSET_IMAGE_DOWNLOADED = "Charisma.Leasing.PublishedLanguage.Events.Asset.AssetImageDownloaded";
